import { defineMessages } from 'react-intl'

const scope = `procurify.components.APUnbilledItemTag`

export default defineMessages({
  blanketItemText: {
    id: `${scope}.blanketOrderItemText`,
    defaultMessage: 'Blanket order item',
  },
})
